const SearchResult = (props) => {
    return (
        <article className="widget__ace-pro">
            <a className="widget__ace-pro-wrap" href={props.result.ProfileURL}>
                <div className={"widget__ace-pro-thumbnail-outer"}>
                    <div className="widget__ace-pro-thumbnail">
                        <img src={props.result.ProfileImageURL} alt={props.result.FullName} />
                    </div>
                </div>
                <div className="widget__ace-pro-caption">
                    <h4 className="widget__ace-pro-name">{props.result.FullName}</h4>
                    <span className="widget__ace-pro-location">{props.result.City}, {props.result.CountryName === "US" || props.result.CountryName === "CA" ? props.result.StateCode : props.result.CountryName}</span>
                    {props.result.CountryName === "US" && props.result.Distance !== null ? [<span className="widget__ace-pro-distance">{props.result.DistanceLabel}</span>] : null}
                    <span className="widget__ace-pro-cert">{props.result.CertDisplay}</span>
                </div>
            </a>
        </article>
    )
}

export default SearchResult